(ns manage.adset.list-view
  (:require ["@mui/material/CircularProgress$default" :as CircularProgress]
            ["@mui/material/Stack$default" :as Stack]
            ["src/svg/artwork/cards.svg$default" :as CardsArtwork]
            [common.patterns.empty-state-view :refer [empty-state-view]]
            [common.queries :refer [use-query]]
            [common.resource.query.campaign :as cq]
            [common.url-template :as url-tpl]
            [manage.adset-table.view :as adset-table.view]
            [manage.campaign-tags-page.view :refer [campaign-tags-page
                                                    use-campaign-tags-page-props]]
            [uix.core :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defui list-view-contents []
  (let [{:keys [campaign-id] :as url-context} (use-subscribe [:url-context])
        {campaign :data is-success :isSuccess} (use-query (cq/campaign-query {:campaign-id campaign-id}))
        campaign-tags-page-props (use-campaign-tags-page-props)]
    (if (and is-success (> (cq/adset-count campaign) 0))
      ($ :<>
         ($ adset-table.view/adset-data-grid)
         ($ campaign-tags-page campaign-tags-page-props))
      (if is-success
        ($ empty-state-view
           {:title "Create an adset"
            :description "You have no adsets yet. Create one to get started."
            :artwork CardsArtwork
            :docs-href (url-tpl/render :docs/article (assoc url-context :slug "24147219143196-How-to-Create-a-Campaign-Adset"))
            :actions ($ adset-table.view/new-adset-button)})
        ($ Stack {:alignItems "center"
                  :sx #js {:width "100%" :height "100%" :paddingTop 25}}
           ($ CircularProgress))))))
